<template lang="pug">
  #ProgramAdminDetails
    //- EMAIL
    BField(
      :type="{'is-danger': errors.has(email.fieldName)}"
      :message="errors.first(email.fieldName)"
    )
      UniquenessCheck(
        label="Email Address"
        :name="email.fieldName"
        entity="memberEmail"
        placeholder="name@email.com"
        v-model="email.value"
        @validName="onValidEmail"
        v-validate="'required'"
        :required="true"
      )
    //- PASSWORD
    BField(
      :type="{'is-danger': errors.has(password.fieldName)}"
      :message="errors.first(password.fieldName)"
      :addons="false"
    )
      WtLabel(
        slot="label"
        :text="'Password'"
        :label-for="password.fieldName"
        required
      )
      BInput(
        ref="password"
        :name="password.fieldName"
        :id="password.fieldName"
        type="password"
        v-validate="'required'"
        placeholder="*********"
        v-model="password.value"
        password-reveal
      )
      PasswordComplexityCheck(:password="password.value")
      BField(
        label="Confirm Password"
        :label-for="passwordConfirm.fieldName"
        :type="{'is-danger': errors.has(passwordConfirm.fieldName)}"
        :message="errors.first(passwordConfirm.fieldName)"
      )
        BInput(
          :name="passwordConfirm.fieldName"
          :id="passwordConfirm.fieldName"
          type="password"
          v-validate="'required|confirmed:password'"
          data-vv-as="password"
          placeholder="*********"
          v-model="passwordConfirm.value"
          password-reveal
        )

</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtLabel from "@@/WtLabel/WtLabel";
import WtTitle from "@@/WtTitle/WtTitle";
import PasswordComplexityCheck from "@@/PasswordComplexityCheck.vue";
import UniquenessCheck from "@@/WtUniquenessCheckInput/WtUniquenessCheckInput";

export default {
  name: "ProgramAdminDetails",

  components: {
    PasswordComplexityCheck,
    UniquenessCheck,
    WtButton,
    WtLabel,
    WtTitle
  },

  data() {
    return {
      firstName: { fieldName: "first-name", value: "Program" },
      lastName: { fieldName: "last-name", value: "Admin" },
      username: { fieldName: "username", value: "" },
      email: { fieldName: "email", value: "" },
      password: { fieldName: "password", value: "" },
      passwordConfirm: { fieldName: "password-confirm", value: "" },
      registeredMemberId: null,
      isEmailValid: false
    };
  },

  computed: {
    formData() {
      return {
        firstName: this.firstName.value,
        lastName: this.lastName.value,
        username: this.username.value,
        email: this.email.value,
        password: this.password.value,
        passwordConfirm: this.passwordConfirm.value
      };
    },

    isPasswordFilled() {
      return (
        !this._.isEmpty(this.password.value) &&
        !this._.isEmpty(this.passwordConfirm.value) &&
        this.password.value === this.passwordConfirm.value
      );
    },

    isAllValid() {
      return !this.errors.any() && this.isEmailValid && this.isPasswordFilled;
    }
  },

  watch: {
    isAllValid() {
      this.$emit("newProgramAdminDetails", {
        isValid: this.isAllValid,
        formData: this.formData
      });
    }
  },

  methods: {
    onValidEmail(event) {
      return (this.isEmailValid = event);
    },
    resetState() {
      this.firstName = { fieldName: "first-name", value: "Program" };
      this.lastName = { fieldName: "last-name", value: "Admin" };
      this.username = { fieldName: "username", value: "" };
      this.email = { fieldName: "email", value: "" };
      this.password = { fieldName: "password", value: "" };
      this.passwordConfirm = { fieldName: "password-confirm", value: "" };
      this.registeredMemberId = null;
      this.isEmailValid = false;
      this.$validator.reset();
    }
  }
};
</script>
